import axios from 'axios';
import { log } from './logger';
import { FIRST_INDEX, getLocaleHeaders, prepareLabURL } from './constants';

import _isEmpty from 'lodash/isEmpty';

export const fetchPasswordValidations = async (orgId, envId, envLab) => {
  let data = [];
  const headers = { 'orgId': orgId };
  try {
    const response = await axios({
      url: `${prepareLabURL(envId, envLab)}/user/getValidations`,
      headers: { ...headers, ...getLocaleHeaders() },
      'Content-Type': 'application/json',
      method: 'POST',
      data: {}
    });
    if(!_isEmpty(response.data) && !_isEmpty(response.data.data)) {
      data = response.data.data[FIRST_INDEX];
    }
  } catch (err) {
    !_isEmpty(err.response.data.errorMessage)?
      log(err.response.data.errorMessage) :
      log('Error in fetchPasswordValidations');
  }
  return data;
};
